<div class="list">
    <h4 class="title">{{title}}</h4>
    <p class="subtitle">{{subtitle}} - {{location}}</p>
    <p class="label">- From {{start}} to {{end}}</p>
</div>